export default __webpack_public_path__ + "71d5f163f2fd18b241822425888f39ef.svg";